import axios from 'axios'
import merge from 'lodash/merge'

const apiUrl = () => {
  if (process && process.env && process.env.NODE_ENV === 'development') {
    return (
      process.env.VUE_APP_AUTHENTIGATE_API_URL ||
      'http://localhost:5002/openlaw-dev/us-central1/app/'
    )
  }
  return '/'
}

export default {
  install(Vue, _options) {
    // axios helpers
    Vue.prototype.$axios = axios
    Vue.prototype.$fireUrl = apiUrl()
    Vue.prototype.$fireConfig = async function (path, auth, method, data) {
      const url = this.$fireUrl + 'api/' + path
      const authHeader =
        'Bearer ' + (auth ? await auth.currentUser.getIdToken() : '')
      const headers = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader
        }
      }

      const config = {
        url: url,
        ...headers,
        method: method,
        data: data
      }

      return config
    }
    Vue.prototype.$firePost = async function (
      path,
      auth,
      data,
      otherConfig,
      onUploadProgressCb
    ) {
      const config = merge(
        {
          ...(await this.$fireConfig(path, auth, 'post', data)),
          onUploadProgress: onUploadProgressCb
        },
        otherConfig
      )
      return axios(config)
    }
    Vue.prototype.$fireGet = async function (path, auth, data, otherConfig) {
      const config = merge(
        { ...(await this.$fireConfig(path, auth, 'get', data)) },
        otherConfig
      )
      // const config = { ...(await this.$fireConfig(path, auth, 'get', data)), ...otherConfig }
      return axios(config)
    }
    Vue.prototype.$fireDelete = async function (path, auth, data, otherConfig) {
      const config = merge(
        { ...(await this.$fireConfig(path, auth, 'delete', data)) },
        otherConfig
      )
      return axios(config)
    }
  }
}
